export default "__VITE_PUBLIC_ASSET__c0a94816__"